module.exports = __webpack_public_path__ + "media/reskin-images/icon--cancel-circle-4e9a2bcf.svg";